import React from "react";
import HealthScreenForm from "./App";

const FullHealthScreenPage = () => {
  return <HealthScreenForm forcedService="full health screen" />;
};

export default FullHealthScreenPage;
